import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-documente-publice',
  templateUrl: './edit-documente-publice.component.html',
  styleUrls: ['./edit-documente-publice.component.scss']
})
export class EditDocumentePubliceComponent {

}
